module.exports = __webpack_public_path__ + "img/icon-dropdown-check.cae6d201.svg";